import React from 'react';
import { ValueFormatterParams } from 'ag-grid-community';

import { absColDef, AdvancedColDef } from '../helpers/advancedHeader';
import { CustomCellRendererProps } from 'ag-grid-react';
import { Checkmark, Close } from '@benzinga/themed-icons';
import { NO_VALUE } from '../../Ticker';

const cellRenderer: React.FC<CustomCellRendererProps> = params => {
  const trueText = params.colDef?.cellRendererParams.trueParam || '';
  const falseText = params.colDef?.cellRendererParams.falseParam || '';
  const trueIcon = params.colDef?.cellRendererParams.trueIcon;
  const falseIcon = params.colDef?.cellRendererParams.falseIcon;
  switch (params.value) {
    case false:
    case 'N':
    case 'false':
    case 0:
    case falseText:
      return (
        <span>
          {falseIcon && <Close className="u-downText" />}
          {falseText}
        </span>
      );

      break;

    case true:
    case 'Y':
    case 'true':
    case 1:
    case trueText:
      return (
        <span>
          {trueIcon && <Checkmark className="u-upText" />}
          {trueText}
        </span>
      );

      break;

    default:
      break;
  }
  return null;
};

export const BooleanColDef = (
  colDef: AdvancedColDef,
  falseText?: string,
  trueText?: string,
  falseIcon = true,
  trueIcon = true,
): AdvancedColDef => ({
  cellRenderer,
  cellRendererParams: {
    falseIcon,
    falseParam: falseText,
    trueIcon,
    trueParam: trueText,
  },
  cellStyle: { textAlign: 'left' },
  filter: 'agSetColumnFilter',
  filterParams: {
    values: trueText && falseText ? [trueText, falseText] : undefined,
  },
  valueFormatter: (data: ValueFormatterParams) => (data.value ? (trueText ?? data.value) : (falseText ?? data.value)),
  valueGetter: params =>
    colDef.field
      ? params.data[colDef.field]
        ? (trueText ?? params.data[colDef.field])
        : (falseText ?? params.data[colDef.field])
      : NO_VALUE,
  ...colDef,
  ...absColDef(colDef),
});
